Librarian.ViewRatingsWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onRatingsLoaded"],

    options: {
        id: "ViewRatingWindow",
        itemType: null,
        itemData: null,
        width: 500,
        height: 300
    },

    rateTemplate: Handlebars.compile("{{#each List}} \
                                        <div class=\"ratings-rate-stars\"> \
                                            <div class=\"left\"> \
                                                {{#drawStars}}{{/drawStars}} \
                                            </div> \
                                            <span class=\"ratings-rate-quality\">{{#translate string=\"rating_quality_\" data=\"{{Count}}\"}}{{/translate}}</span> \
                                            <span class=\"ratings-rate-date\">{{#formattedDate format=\"%B %d, %Y\" date=\"{{LogDate}}\"}}{{/formattedDate}}</span> \
                                        </div> \
                                        <div class=\"ratings-view-comment\"> \
                                            <span class=\"ratings-rate-user\">By <span class=\"ratings-rate-user-name\">{{UserFirstName}} {{UserLastName}}</span></span> \
                                            <span class=\"ratings-rate-view-text\">{{#comment string=\"{{ContentText}}\"}}{{/comment}}</span> \
                                        </div> \
                                        <hr class=\"ratings-view-break\" /> \
                                      {{/each}}"),

    initialize: function(options) {
        this.setOptions(options);

        if (this.options.itemData == null)
            return;

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("rating_view_title");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/ratings/viewratingswindow.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var ratingTitle = Librarian.Lang.getString("rating_view_type");
        if (this.options.itemType == "slide") {
            var type = Librarian.Utils.getItemTypeString(this.options.itemData);
            ratingTitle += ' ' + type.toLowerCase() + " #" + this.options.itemData.slidenumber;
        }
        Librarian.Utils.setElementValue(this.getElement("rateType"), ratingTitle + ": ");

        var name;
        if (this.options.itemType == "file") {
            if (this.options.itemData.presid > 0)
                name = this.options.itemData.name;
            else
                name = this.options.itemData.groupname || this.options.itemData.filename || this.options.itemData.name;
        }
        else {
            name = this.options.itemData.filename || this.options.itemData.name;

            // If this name ends in the extension of the file, strip it off because this is a slide/page
            var ext = Librarian.Utils.getExtensionFromData(this.options.itemData, true);
            if ((ext.length > 0) && name.endsWith(ext))
                name = name.substring(0, name.length - ext.length - 1);
        }

        if ((typeof name != "undefined") && (name != null))
            Librarian.Utils.setElementValue(this.getElement("rateName"), name);

        Handlebars.registerHelper("drawStars", function() {
            var html = [];
            for (var i = this.Count; i--;)
                html.push("<span class='ratings-rate-star ratings-rate-star-on'></span>");

            var emptyStars = 5 - this.Count;
            for (var i = emptyStars; i--;)
                html.push("<span class='ratings-rate-star'></span>");

            return new Handlebars.SafeString(html.join(''));
        });

        Handlebars.registerHelper("translate", function(options) {
            var data = Handlebars.compile(options.hash.data);
            return Librarian.Lang.getString(options.hash.string + data(this)) + ", ";
        });

        Handlebars.registerHelper("comment", function(options) {
            var comment = Handlebars.compile(options.hash.string);
            return comment(this).replaceAll("\n", "<br />");
        });

        var id = "&cntid=";
        // Build the ID string for files and groups
        if (this.options.itemData.groupid > 0) {
            id += this.options.itemData.groupid + "&cnttype=";
            if (typeof this.options.itemData.eventcount == "number")
                id += Librarian.contentType.eventGroup;
            else
                id += Librarian.contentType.globalFavorite;
        }
        else if (this.options.itemData.presid > 0)
            id += this.options.itemData.presid + "&cnttype=" + Librarian.contentType.myFavorite;
        else if (this.options.itemData.fileid > 0)
            id += this.options.itemData.fileid + "&cnttype=" + Librarian.contentType.file;
        else if (this.options.itemData.eventgroupinfo && (this.options.itemData.eventgroupinfo.groupid > 0))
            id += this.options.itemData.eventgroupinfo.groupid + "&cnttype=" + Librarian.contentType.eventGroup;

        // If this is a slide
        if (this.options.itemType == "slide") {
            // Use the slide ID if we can
            if (this.options.itemData.slideid > 0)
                id = "&cntid=" + this.options.itemData.slideid + "&cnttype=" + Librarian.contentType.slide;
            // Otherwise, use the slide number
            else
                id += "&snum=" + this.options.itemData.slidenumber;
        }

        this.request = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getrates") + id + "&out=ujson",
            onSuccess: this.onRatingsLoaded,
            onFailure: Librarian.Utils.onFailure
        });
        this.request.send();
    },

    onClose: function() {
        this.parent();

        if (this.request) {
            this.request.cancel();
            this.request = null;
        }
    },

    onRatingsLoaded: function(json) {
        var commentEl = this.getElement("rateComments");

        if (!json || !json.List || (json.List.length == 0)) {
            commentEl.set("text", "No Comments");
            return;
        }

        commentEl.set("html", this.rateTemplate(json));
    }
});